/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseProfileCountries } from '../../models/response-profile-countries';

export interface ListProfileCountries$Params {
  companyType: string;

/**
 * Language of returned countries ISO 3166-1
 */
  language: 'SK' | 'CZ' | 'US' | 'DE' | 'ES' | 'SI' | 'PL' | 'AR' | 'GB' | 'PT' | 'HU';
}

export function listProfileCountries(http: HttpClient, rootUrl: string, params: ListProfileCountries$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseProfileCountries>>> {
  const rb = new RequestBuilder(rootUrl, listProfileCountries.PATH, 'get');
  if (params) {
    rb.path('companyType', params.companyType, {});
    rb.path('language', params.language, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponseProfileCountries>>;
    })
  );
}

listProfileCountries.PATH = '/rest/profile/list-profile-countries/{companyType}/{language}';
